import { ShieldCheck, Film, CalendarClock } from "lucide-react";

const CONTROLLI = [
  ["Novità", "C'è un fatto nuovo rispetto agli ultimi 7 giorni?"],
  ["Specificità", "Chi ha fatto cosa, dove, con quale conseguenza. Niente «il sistema» senza atto/norma/numero."],
  ["Share-trigger", "Perché uno lo manderebbe in privato? Utilità, identità, sorpresa o prova visiva."],
  ["Emozione unica", "Una sola: rabbia / indignazione / speranza / orgoglio. Il minestrone non gira."],
  ["Frase inoltrabile", "La riga che uno manda all'amico su WhatsApp. Si scrive PRIMA di girare."],
];

const FRAMES = [
  { id: "01", nome: "Attualità · senza CTA", formula: "Notizia nuda → paradosso (responsabile = l'ATTO) → concessione («è vero che…, però») → tesi → PUNCHLINE. Stop.", uso: "Cronaca commentata · Dato che ribalta · Reaction · Lun P.IVA" },
  { id: "02", nome: "Storia / Oggetto · senza CTA", formula: "Oggetto o contrasto impossibile → storia (luogo, nomi, numeri) → secondo caso → Davide contro Golia → scudo preventivo → tesi + legame personale → punchline.", uso: "Sab «Non fa notizia» · Dom «Italia vs Europa» · Oggetto→tesi (busta paga, scontrino, ISEE)" },
  { id: "03", nome: "Acquisizione · con CTA", formula: "Promessa + autorità → VALORE completo (3 micro-lezioni) → prova personale → alibi distrutto → ponte «più facile a dirsi che a farsi» → «INIZIAMO» → rinforzo. Per 2 minuti non chiede nulla.", uso: "Soluzione · reel pre-workshop · app Diagnosi. UNA sola CTA, niente domanda finale." },
];

export function MetodoPanel({ profile }) {
  return (
    <section className="grid grid-cols-1 xl:grid-cols-3 gap-6" data-testid="strategy-metodo">
      <div className="border border-[#262626] rounded-xl bg-[#111111] p-6" data-testid="strategy-controlli">
        <h3 className="font-display font-bold text-white flex items-center gap-2 mb-4"><ShieldCheck size={18} style={{ color: "#D97706" }} /> I 5 controlli anti-flop</h3>
        <ol className="space-y-3">
          {CONTROLLI.map(([t, d], i) => (
            <li key={t} className="flex gap-3">
              <span className="font-display font-extrabold text-lg leading-none w-6 shrink-0" style={{ color: "#D97706" }}>{i + 1}</span>
              <div><p className="text-sm font-semibold text-white">{t}</p><p className="text-xs text-neutral-500 leading-snug">{d}</p></div>
            </li>
          ))}
        </ol>
        <p className="text-[0.68rem] text-neutral-600 mt-4">Se ne manca uno: riangola o scarta. Anche se «farebbe numeri».</p>
      </div>

      <div className="border border-[#262626] rounded-xl bg-[#111111] p-6" data-testid="strategy-frames">
        <h3 className="font-display font-bold text-white flex items-center gap-2 mb-4"><Film size={18} style={{ color: "#D97706" }} /> I 3 frame del reel</h3>
        <div className="space-y-4">
          {FRAMES.map((f) => (
            <div key={f.id} className="border-l-2 pl-3" style={{ borderColor: f.id === "03" ? "#16A34A" : "#D97706" }}>
              <p className="text-sm font-semibold text-white">Frame {f.id} · {f.nome}</p>
              <p className="text-xs text-neutral-400 leading-snug mt-1">{f.formula}</p>
              <p className="text-[0.68rem] text-neutral-600 mt-1">Quando: {f.uso}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="border border-[#262626] rounded-xl bg-[#111111] p-6 space-y-4" data-testid="strategy-mix">
        <h3 className="font-display font-bold text-white flex items-center gap-2"><CalendarClock size={18} style={{ color: "#D97706" }} /> Mix settimanale e rito</h3>
        <div><p className="text-[0.65rem] uppercase tracking-[0.2em] mb-1" style={{ color: "#D97706" }}>I 7 contenuti</p><p className="text-sm text-neutral-200 leading-relaxed">{profile?.mix_settimanale}</p></div>
        <div><p className="text-[0.65rem] uppercase tracking-[0.2em] mb-1" style={{ color: "#D97706" }}>La chiusura</p><p className="text-sm text-neutral-200 leading-relaxed">{profile?.chiusura}</p></div>
        <div className="rounded-lg p-3 border" style={{ background: "rgba(217,119,6,0.08)", borderColor: "rgba(217,119,6,0.3)" }}><p className="text-[0.65rem] uppercase tracking-[0.2em] mb-1 text-neutral-400">Il rito</p><p className="text-sm text-white leading-relaxed">{profile?.rito}</p></div>
      </div>
    </section>
  );
}
